import type { ModuleManifest } from '../types';
import { routes } from './routes';
import { navItems } from './nav';

/**
 * Project Management module manifest (P10)
 *
 * Installation project management with native Firestore collections.
 * Equipment tracking, schedule blocks, meeting mode, and calendar views.
 */
export const projectsModule: ModuleManifest = {
  id: 'P10',
  name: 'Projects',
  shortName: 'Projects',
  description: 'Installation project management, equipment tracking, scheduling, and document management',
  icon: '📋',
  status: 'live',
  urlPrefix: '/projects',
  routes,
  navItems,
  collections: {
    APPSHEET_SCHEDULE_BLOCKS: 'appsheet_schedule_blocks',
  },
};

export default projectsModule;
